import { ResortPhotosData } from 'components/widget/types';
import React, { useMemo } from 'react';
import { SwiperComponent, SwiperSlideItem } from 'components/blocks/SwiperComponent';
import { ImageComponent } from 'components/common/ImageComponent';
import styles from './styles.module.scss';
import { SectionHeader } from '../SectionHeader';

interface Props {
  photos: ResortPhotosData;
  resortDescription?: { dangerouslySetInnerHTML: { __html: string; }; };
  title? : string;
  isSummerMode?: boolean;
}

export const OverviewTopSlider = ({
  photos, resortDescription, title, isSummerMode = false,
}:Props) => {
  const slides: SwiperSlideItem[] = useMemo(() => photos.map((item) => ({
    key: item.cdnUrl,
    content: (
      <ImageComponent
        alt={item.name}
        src={item.cdnUrl}
      />
    ),
  })), [photos]);

  return (
    <section id={styles.slider}>
      <div>
        <SwiperComponent
          slides={slides}
          navigationThreshold={1}
          spaceBetween={0}
          slideClassName={styles.height_auto}
          navButtonClassName={styles.swiperNavButton}
          prevButtonClassName={styles.swiperButtonPrev}
          nextButtonClassName={styles.swiperButtonNext}
        />
      </div>
      <SectionHeader title={title} description={resortDescription} isSummerMode={isSummerMode} />
    </section>
  );
};
